import React from 'react';
import classnames from 'classnames/bind';
import Header from '../../components/Header/Header';
import Hero from '../../components/Hero/Hero';
import HowItWorks from '../../components/HowItWorks/HowItWorks';
import Capabilities from '../../components/Capabilities/Capabilities';
import Waitlist from '../../components/Waitlist/Waitlist';
import Footer from '../../components/Footer/Footer';
import styles from './Home.module.scss';

const cx = classnames.bind(styles);

export default function Home() {
    return (
        <div className={cx('Container')}>
            <Header />
            <main>
                <Hero />
                <HowItWorks />
                <Capabilities />
                <Waitlist />
            </main>
            <Footer />
        </div>
    );
}
